<template>
	<div>
		<Supziliao v-if="iszl" :ziliaoprj="ziliaoprj" @close="iszl=false" @hcziliao='shondanziliao'></Supziliao>
		<div class="content" @click="showindex = -1">
			<div class="msg" @click="showindex = -1">
				<div class="msg-main" v-for="(item, index) in menu" :key="index">
					<div class="msg-menu" @mouseenter="Showlist(index)" @click.stop="Showlist(index)">
						<img :src="item.list[0].imgUrl" class="msg-img" />
						{{ item.name }}
					</div>
					<div class="mingxi" v-if="index == showindex">
						<div class="mingxi-content" v-for="(c, i) in item.list" :key="i"
							@mouseenter="Smovelist(c.projectTypeId)"
							:class="{ 'mingxi-content1': c.projectTypeId == movelist }" @click="sealist(c)">
							{{ c.projectType }}
						</div>
					</div>
				</div>
			</div>

			<div class="content-main">
				<div class="content-left">
					<div class="left-tou">
						{{ displayText }}
					</div>
					<div class="left-center">
						<div class="left-list" v-for="(s, index) in zylist" :key="index"
							:class="{ 'mingxi-content1': s.subclassId == zyindex }" @click="
                cxzl(s);
                Smovezy(s.subclassId);
              ">
							{{ s.industryTypeName }}
						</div>
					</div>
				</div>
				<div class="content-center">
					<div class="zlqd-tou">
						<div class="zlqd-title">
							新项目注册<div class="zlqd-shuom" v-if="industryTypeId">（注册后，可在<span
									class="Sblack">“我的项目”</span>中查看并补充/更新资料）
							</div>
						</div>
						<div class="zlqd-jiage">

							<el-button v-if="zllist.length > 0&&name" size="small" type="primary"
								@click="wtbz">提交委托</el-button>

						</div>
					</div>
					<div class="zlqd-list">
						<div class="zlqd-content">
							<div class="name-list">
								<div class="name">
									<div class="title">委托人：</div>
									<div class="xm-content" :class="{'xm-content1':ists}">{{wtrts()}}</div>
								</div>
								<div class="name">
									<div class="title">项目类别：</div>
									<div class="xm-content">{{Sclass()}} </div>
								</div>
								<div class="name">
									<div class="title">项目价格：</div>
									<div class="xm-content">
										{{xmjg()}}
									</div>
								</div>
								<div class="name">
									<div class="title">项目名称：</div>
									<div class="xm-content" v-if="industryTypeId">
										<input type="text" class="input-control" v-model="prjname"
											placeholder="请填写项目名称"></input>
										<span class="clear-icon" v-if="prjname" @click="prjname = ''">×</span>

									</div>
								</div>
								<div class="name">
									<div class="title">编制期限：</div>
									<div class="xm-content" v-if="industryTypeId">
										<el-radio-group v-model="bzqx">
											<el-radio :label="1">正常{{bz.prepareCycle}}天</el-radio>
											<el-radio :label="0">加急{{Math.ceil(bz.prepareCycle/2)}}天</el-radio>
										</el-radio-group>
										<div class="Sqixian"><span class="Sastar">*</span><span
												class="sl">资料齐全且付款后启动编制倒计时</span></div>

									</div>
								</div>
								<div class="name">
									<div class="title">建设性质：</div>
									<div class="xm-content" v-if="industryTypeId">
										<el-radio-group v-model="jsxz">
											<el-radio :label="'新建'">新建</el-radio>
											<el-radio :label="'改造'">改造</el-radio>
											<el-radio :label="'扩建'">扩建</el-radio>
										</el-radio-group>
									</div>
								</div>
								<div class="name" v-if="industryTypeId">
									<div class="title">建设周期：</div>
									<div class="xm-content">
										<Ssqbz :initStartDate="stardate" :initEndDate="enddate"
											@dateChange="handleDateRangeChange"></Ssqbz>
									</div>
								</div>
								<div class="name">
									<div class="title">其他说明：</div>
								</div>
								<div class="name" v-if="industryTypeId">
									<div class="xm-content">
										<el-input type="textarea" v-model="content" :rows="5" :maxlength="1500"
											placeholder="请输入说明（最多1500字）" show-word-limit
											style="width: 34vw;padding-left: 5px;" resize="none"></el-input>
										<span class="content-icon" v-if="content" @click="content = ''">×</span>
									</div>

								</div>
							</div>

						</div>
						<div class="zlqd-content">
							<div class="zlqd-Stile">需提资料清单(注册完成后在“我的项目”中上传资料)
								<div class="tools" v-if="JSON.stringify(bz)!=='{}'">
									<el-button size="mini" type="text" @click="downloadWord">
										<i class="el-icon-download"></i>
										下载清单
									</el-button>
									<!-- <el-button size="mini" type="text">
										<i class="el-icon-upload"></i>
										上传资料
									</el-button> -->
								</div>

							</div>
							<div class="zlqd-li">
								<div class="zlqd-contitle" v-for="(item, ind) in zllist" :key="ind">
									{{ ind + 1 }}.{{ item.informationTypeName }}
								</div>
							</div>

						</div>
					</div>
					<div class="content-center-z" v-if="isbz">

					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	import {
		subclass,
		zyemg,
		prjpush
	} from "../../utils/request.js";
	import Ssqbz from "./Ssqbz.vue";
	import Supziliao from "./Supziliao.vue";
	import {
		Setitem,
		Getitem
	} from "../../utils/item.js";

	import {
		Document,
		Packer,
		Paragraph,
		TextRun,
		HeadingLevel
	} from 'docx'


	export default {
		data() {
			return {
				menu: Getitem('setmenu'),
				movelist: -1,
				showindex: -1,
				discipline: "",
				zylist: [],
				zyindex: -1,
				zllist: [],
				jiage: "",
				zhouqi: "",
				xishu: "",
				isbz: false,
				bz: {},
				ists: false,
				bzqx: 1,
				jsxz: '新建',
				prjname: '',
				content: '',
				name: Getitem('name'),
				stardate: '',
				enddate: '',
				iszl: false,
				ziliaoprj: {},
				projectTypeId: '',
				industryTypeId: '',
				ssdata: {}


			};
		},
		components: {
			Ssqbz,
			Supziliao
		},
		methods: {
			downloadWord() {
				if (this.zllist.length === 0) {
					this.$toast.error('没有资料清单可下载')
					return
				}

				try {
					// 创建HTML内容
					let htmlContent = `
	                    <!DOCTYPE html>
	                    <html>
	                    <head>
	                        <meta charset="UTF-8">
	                        <title>资料清单</title>
	                        <style>
	                            body { 
	                                font-family: "Microsoft YaHei", "SimSun", sans-serif; 
	                                margin: 20px; 
	                                line-height: 1.6;
	                            }
	                            h1 { 
	                                color: #333; 
	                                text-align: center; 
	                                margin-bottom: 20px;
	                                border-bottom: 2px solid #409eff;
	                                padding-bottom: 10px;
	                            }
	                            .info-section {
	                                margin-bottom: 20px;
	                                padding: 15px;
	                                background-color: #f5f7fa;
	                                border-radius: 5px;
	                            }
	                            .info-item {
	                                margin: 8px 0;
	                            }
	                            .info-label {
	                                font-weight: bold;
	                                color: #333;
	                                min-width: 80px;
	                                display: inline-block;
	                            }
	                            .list-title {
	                                font-size: 18px;
	                                font-weight: bold;
	                                color: #409eff;
	                                margin: 20px 0 10px 0;
	                            }
	                            .list-item {
	                                margin: 10px 0;
	                                padding-left: 20px;
	                                position: relative;
	                            }
	                            .list-item:before {
	                                content: "•";
	                                color: #409eff;
	                                font-size: 20px;
	                                position: absolute;
	                                left: 0;
	                                top: -2px;
	                            }
	                            .item-index {
	                                font-weight: bold;
	                                color: #333;
	                                margin-right: 8px;
	                            }
	                            .footer {
	                                margin-top: 30px;
	                                text-align: right;
	                                color: #666;
	                                font-size: 12px;
	                                border-top: 1px dashed #ddd;
	                                padding-top: 10px;
	                            }
	                        </style>
	                    </head>
	                    <body>
	                        <h1>项目资料清单</h1>
	                        
	                        <div class="info-section">
	                            
	                            <div class="info-item">
	                                <span class="info-label">项目类别：</span>
	                                ${this.Sclass() || '未选择项目类别'}
	                            </div>
								<div class="info-item">
								    <span class="info-label">编制期限：</span>
								
								   正常 ${this.bz.prepareCycle}天，加急${Math.ceil(this.bz.prepareCycle/2)}天
								</div>
								<div class="info-item">
								    <span class="info-label">费用：</span>
								
								   正常： ${this.bz.preparePrices}元，加急：${this.bz.preparePrices * this.bz.factor}元
								</div>
								
								
	                            
	                        </div>
	                        
	                        <div class="list-title">需提资料清单（共${this.zllist.length}项）</div>
	                `;

					// 添加清单列表
					this.zllist.forEach((item, index) => {
						htmlContent += `
	                        <div class="list-item">
	                            <span class="item-index">${index + 1}.</span>
	                            <strong>${item.informationTypeName}</strong>
	                        </div>
	                    `;
					});

					htmlContent += `
	                        <div class="footer">
	                            系统自动生成 · ${new Date().getFullYear()}年${new Date().getMonth()+1}月${new Date().getDate()}日
	                        </div>
	                    </body>
	                    </html>
	                `;

					// 创建Blob并下载
					const blob = new Blob([htmlContent], {
						type: 'application/msword'
					});

					// 生成文件名
					const projectName = this.Sclass();
					const fileName = `资料清单_${projectName}.doc`;

					// 使用原生的下载方法
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = fileName;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(link.href);

					this.$toast.success('资料清单下载成功');
				} catch (error) {
					// console.error('生成文档失败:', error);
					this.$toast.error('下载失败，请重试');
				}
			},

			async wtbz() {
				if (!this.projectTypeId || !this.industryTypeId) {
					this.$toast.error('没有选择项目类别')
					return
				}
				if (!this.prjname) {
					this.$toast.error('没有填写项目名称')
					return
				}
				if (!this.stardate || !this.enddate) {
					this.$toast.error('没有填写项目建设周期')
					return
				}
				const start = new Date(this.stardate).getTime();
				const end = new Date(this.enddate).getTime();
				if (start > end) {
					this.$toast.error('建设周期开始时间不能在结束时间之后！')
					return

				}

				let Szllist = []
				this.zllist.forEach((res, index) => {
					let s = {}
					s.examineFlag = res.examineFlag ? res.examineFlag : 0
					s.informationTypeId = res.informationTypeId
					s.Files = JSON.stringify(res.Files ? res.Files : '')
					s.content = res.content ? res.content : ''
					Szllist.push(s)

				})


				let data = { //需要传给接口的数据
					projectTypeId: this.projectTypeId, //项目类型ID
					industryTypeId: this.industryTypeId, //项目专业ID
					projectAmount: this.xmjg(), //项目价格
					projectName: this.prjname, //项目名称
					cycle: this.bzqx == 1 ? this.bz.prepareCycle : 0, //编制期限
					nature: this.jsxz, //项目建设性质
					startDate: this.stardate, //项目开始时间
					finishDate: this.enddate, //项目结束时间
					description: this.content, //项目说明
					information: Szllist
				}
				let res = await prjpush(data)
				if (res.code === 200) {
					this.$toast.success('注册成功,后续工作可在“我的项目”中完成！');

					// -------------------------- 新增：提交成功后重置所有变量 --------------------------
					this.movelist = -1; // 二级菜单选中索引
					this.showindex = -1; // 一级菜单展开索引
					this.discipline = ""; // 项目类别文本
					this.zylist = []; // 专业列表
					this.zyindex = -1; // 专业选中索引
					this.zllist = []; // 资料清单列表
					this.jiage = ""; // 价格
					this.zhouqi = ""; // 周期
					this.xishu = ""; // 系数
					this.isbz = false; // 编制弹窗标识
					this.bz = {}; // 编制配置信息
					this.ists = false; // 未登录提示样式标识
					this.bzqx = 1; // 编制期限（默认正常）
					this.jsxz = '新建'; // 建设性质（默认新建）
					this.prjname = ''; // 项目名称
					this.content = ''; // 其他说明
					this.stardate = ''; // 建设开始时间
					this.enddate = ''; // 建设结束时间
					this.iszl = false; // 资料上传弹窗标识
					this.ziliaoprj = {}; // 资料上传弹窗参数
					this.projectTypeId = ''; // 项目类型ID
					this.industryTypeId = ''; // 专业ID
					this.ssdata = {}; // 其他备用数据
					// --------------------------------------------------------------------------------

				} else {
					this.$toast.error(res.msg)
				}
				// console.log(res);

			},
			shondanziliao(e) {
				e.Snum = 0
				if (e.content !== '') {
					e.Snum = e.Snum + 1
				}
				e.Snum = e.Snum + e.Files.length
				e.examineFlag = 0

				this.zllist.forEach((res, index) => {
					if (res.informationTypeId === e.informationTypeId) {
						this.zllist[index] = e;
					}
				});
			},
			Supqingdan(item) {

				this.iszl = true
				this.ziliaoprj = item
				// console.log(item);
			},

			xmjg() {
				if (JSON.stringify(this.bz) == '{}') return
				if (this.bzqx != 0) {
					return this.bz.preparePrices + '元'
				} else {
					return this.bz.preparePrices * this.bz.factor + '元'
				}
			},
			handleDateRangeChange(range) {
				this.stardate = range.startDate
				this.enddate = range.endDate
			},
			Sclass() {

				if (JSON.stringify(this.bz) === '{}') return
				return `${this.discipline}（${this.bz.industryTypeName}）`
			},
			wtrts() {
				if (!this.name) {
					this.ists = true
					let m = "你没有登录，无法委托，我们也无法为您发送成果！"
					return m
				} else {
					return this.name
				}
			},
			sqbz() {
				this.isbz = true;
			},
			async cxzl(res) {
				this.industryTypeId = res.industryTypeId
				let id = res.subclassId;
				this.bz = res;
				// this.$store.commit('setSbz', res)
				// console.log('这是专业：', this.bz);

				this.zllist = [];
				this.jiage = "";
				this.zhouqi = "";
				this.xishu = "";
				this.jiage = res.preparePrices;
				this.zhouqi = res.prepareCycle;
				this.xishu = res.factor;
				let s = await zyemg(id);
				if (s.code === 200) {
					this.zllist = s.list;

				} else {
					this.$toast.error(s.msg)
				}
			},

			Smovezy(id) {
				this.zyindex = id;
			},

			async sealist(c) {
				// console.log(c);
				this.industryTypeId = ''

				this.projectTypeId = c.projectTypeId

				this.discipline = c.projectType;
				this.bz = {}

				this.zylist = []

				let li = await subclass(c.projectTypeId);
				if (li.code == 200) {

					this.zylist = li.list;
				} else {
					this.$toast.error(li.msg)
				}
			},
			Showlist(index) {
				this.showindex = index;
			},
			Smovelist(num) {
				this.movelist = num;
			},
		},
		created() {
			// console.log(this.$route.name);


		},
		watch: {
			'$store.state.username'(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.name = newVal;
					if (this.name === '') {
						this.iszl = false
					}

				}
			},
			'$store.state.porjecttype'(newVal, oldVal) {
				let sn = newVal

				if (JSON.stringify(sn) !== '{}') {
					this.sealist(sn)
					setTimeout(() => {
						let m = {}
						this.$store.commit('setporjecttype', m);
					}, 100);
				}

			},
		},
		computed: {
			displayText() {
				return this.discipline ? this.discipline : "请选择类型";
			},
		},
	};
</script>

<style lang="less" scoped>
	.content {
		height: 92vh;
		width: 100vw;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		top: 8vh;
		z-index: 10;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: aliceblue;
	}

	.content-main {
		height: 70vh;
		width: 100vw;
		margin-top: 15px;
		/* background-color: white; */
		display: flex;
		justify-content: start;
		align-items: center;

		.content-left {
			width: 15vw;
			height: 90%;
			background-color: #fdfdfd;
			border-radius: 10px;
			box-shadow: 0 5px 5px rgba(0, 0, 0, 0.6);
			margin-left: 15px;

			.left-tou {
				width: 85%;
				margin: auto;
				padding: 7px 7px 5px 7px;
				font-size: 17px;
				text-align: center;
				line-height: 35px;
				font-weight: bold;
				border-bottom: 1px solid #dfdfdf;
				margin-bottom: 5px;
			}

			.left-center {
				height: 87%;
				width: 92%;
				margin: 0 auto;
				display: flex;
				flex-direction: column;
				align-items: start;
				// justify-content: center;
				line-height: 30px;
				padding-top: 6px;
				padding-left: 10px;
				overflow: auto;
				scrollbar-width: none;
				-ms-overflow-style: none;


				.left-list {
					width: 100%;
					text-align: left;
					font-size: 12.5px;
					line-height: 30px;
					border-bottom: 1px dashed #ececec;
					cursor: pointer;
				}

				.left-list:hover {
					color: #409eff !important;
				}
			}
		}

		.content-center {
			width: 80vw;
			height: 63vh;
			background-color: #409eff;
			margin-left: 1.5vw;
			background-color: #fdfdfd;
			border-radius: 10px;
			box-shadow: 0 5px 5px rgba(0, 0, 0, 0.6);
			display: flex;
			flex-direction: column;
			align-content: center;
			justify-content: start;
			position: relative;

			.content-center-z {
				width: 80vw;
				height: 63vh;
				background-color: #409eff;
				// margin-left: 1.5vw;
				background-color: #fdfdfd;
				border-radius: 10px;
				box-shadow: 0 5px 5px rgba(0, 0, 0, 0.6);
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				z-index: 50;
			}

			.zlqd-tou {
				width: 78vw;
				height: 5.5vh;
				margin: 0 auto;
				display: flex;
				justify-content: left;
				align-items: center;
				font-weight: bold;
				font-size: 17px;
				border-bottom: 1px solid #dfdfdf;
				position: relative;

				.zlqd-title {

					padding-left: 15px;
					padding-top: 5px;
					display: flex;
					align-items: center;
				}

				.zlqd-jiage {

					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					// width: 420px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 13px;
					padding-top: 5px;
					padding-right: 30px;

					.jiage {
						width: 140px;
					}
				}
			}

			.zlqd-list {
				width: 78vw;
				height: 54vh;
				margin: 0 auto;
				// background-color: #18688d;
				margin-top: 1.5vh;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.zlqd-content {
					width: 37.5vw;
					height: 53vh;
					background-color: rgba(233, 233, 233, 0.5);
					box-shadow: 0 2px 2px rgba(0, 0, 0, 0.6);
					border-radius: 0 0 10px 10px;
					padding: 8px;
					position: relative;

					.wt-but {
						position: absolute;
						bottom: 10px;
						left: 50%;
						transform: translate(-50%, -50%);
					}

					.zlqd-Stile {
						height: 3vh;
						width: 100%;
						font-size: 15px;
						font-weight: bold;
						text-align: start;
						border-bottom: 1px solid #dfdfdf;
						display: flex;
						position: relative;

						.tools {
							position: absolute;
							top: 50%;
							right: 0px;
							transform: translateY(-50%);
							display: flex;
							align-items: center;
							justify-content: end;
							// gap: 15px;
							// width: 150px;

							.downlist {
								font-size: 13px;
								display: flex;
								align-items: center;
								// gap: 5px;
								cursor: pointer;
								padding: 4px 8px;
								border-radius: 4px;
								transition: all 0.3s;

								&:hover {
									background-color: #f0f0f0;
									color: #409eff;
								}

								.el-icon {
									font-size: 14px;
								}
							}
						}


					}

					.zlqd-li {
						height: 50vh;
						width: 100%;
						overflow-y: auto;
						overflow-x: hidden;
						scrollbar-width: none;
						-ms-overflow-style: none;


						.zlqd-contitle {
							height: 3vh;
							display: flex;
							align-items: center;
							// justify-content: center;
							border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
							font-size: 12px;
							text-align: left;
							position: relative;

							.upshuoming {
								position: absolute;
								top: 50%;
								right: -5px;
								transform: translate(-50%, -50%);
								display: flex;
								align-items: center;
								justify-content: end;

								.uptext {
									font-weight: bold;
									color: #409eff;
									margin -right: 10px;
									border: 1px solid #409eff;
									width: 16px;
									height: 16px;
									border-radius: 50%;
									display: flex;
									align-items: center;
									justify-content: center;
									cursor: pointer;
								}


							}


						}
					}

					.name-list {
						margin: auto;
						width: 36vw;
						height: 52vh;
						line-height: 40px;
						display: flex;
						flex-direction: column;
						justify-content: start;
						align-items: start;
						padding: 10px 15px;

						.name {
							font-size: 15px;
							line-height: 40px;
							padding: 5 10px;
							text-align: left;
							display: flex;
							align-items: center;
							justify-content: start;

							.title {
								width: 80px;
								text-align: right;
							}

							.titlesf {
								width: 80px;
								display: flex;
								align-items: flex-start;
							}

							.xm-content1 {
								padding: 2px 0;
								font-weight: 200 !important;

							}

							.xm-content {
								font-weight: bold;
								position: relative;
								display: flex;
								align-items: center;
								position: relative;

								.content-icon {
									position: absolute;
									top: -5px;
									right: -5px;
									width: 30px;
									height: 30px;
									font-size: 20px;
									color: #d5d5d5;
									cursor: pointer;
								}

								.Sqixian {
									font-weight: 100;
									padding-left: 15px;
									font-size: 18px;
									color: red;
									display: flex;
									align-items: center;

									.Sastar {
										padding-top: 7px;
									}

									.sl {
										font-size: 12px;
										color: #606266
									}
								}

								.input-control {
									width: 30vw;
									height: 40px;
									padding: 0 25 0 5px;
									padding-right: 40px;
									padding-left: 10px;
									border: 1px solid #dcdfe6;
									border-radius: 4px;
									font-size: 14px;
									color: #606266;
									transition: border-color 0.2s;
									box-sizing: border-box;
									background: #fff;
									position: relative;
									z-index: 2;


									&:focus {
										border-color: #409eff;
										outline: none;
									}
								}

								.clear-icon {
									font-size: 20px;
									width: 25px;
									height: 40px;
									position: absolute;
									top: 50%;
									left: 29vw;
									transform: translate(-50%, -50%);
									z-index: 30;
									cursor: pointer;
									color: #d5d5d5;

								}
							}

							.xm-content1 {
								font-size: 12px;
								color: red;
							}


						}
					}

				}
			}
		}
	}

	.msg {
		width: 100vw;
		height: 10vh;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 20px;
		background-color: #fdfdfd;
		height: 15vh;
		box-shadow: 0 5px 5px -1px rgba(0, 0, 0, 0.6);

		.msg-main {
			/* display: flex; */
			position: relative;

			.msg-menu {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin: 0 40px;
				color: #18688d;
				font-size: 15px;
				font-weight: 700;

				.msg-img {
					width: 60px;
					height: 60px;
					border-radius: 50%;
					border: 1px solid #454962;
					background-color: #e5e5e5;
					box-shadow: 0 5px 16px rgba(0, 0, 0, 0.6);
					margin-bottom: 10px;
				}
			}

			.mingxi {
				position: absolute;
				top: 100%;
				left: 0;
				right: 0;
				margin: 0 auto;
				/* 关键：横向居中 */
				/* bottom: 0; */
				z-index: 100;
				font-size: 13px;
				line-height: 25px;
				border: 1px solid #d5d5d5;
				border-radius: 5px;
				display: flex;
				flex-direction: column;
				align-items: start;
				padding: 10px;
				background-color: #e5e5e5;
				box-shadow: 0 2px 2px rgba(0, 0, 0, 0.6);
				cursor: pointer;

				/* font-size: 12px; */
			}
		}
	}

	@keyframes bounce {

		0%,
		100% {
			transform: translateY(0);
			/* 初始和结束位置 */
		}

		50% {
			transform: translateY(-10px);
			/* 中间位置（向上跳10px） */
		}
	}

	.msg .msg-menu {
		/* 增加过渡，让动画更平滑 */
		transition: transform 0.3s ease;
	}

	/* 鼠标 hover 时触发动画 */
	.msg .msg-menu:hover {
		animation: bounce 0.5s ease;
		/* 动画名称、时长、缓动效果 */
		cursor: pointer;
		/* 鼠标变成手型，提示可点击 */
	}

	.mingxi-content1 {
		color: #409eff !important;
		font-weight: bold;
	}

	.a {
		width: 100vw;
		height: 60vh;
		position: absolute;
		top: 0;
		left: 0;
		background-color: aliceblue;
		z-index: 999;

	}

	.zlqd-shuom {
		font-size: 13px;
		font-weight: 200;
		color: red;

		.Sblack {
			color: #606266;
		}
	}
</style>